/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_DofollowInputs */

const en_directory_submit_review_dofollow = /** @type {(inputs: Directory_Submit_Review_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow (badge verified)`)
};

const zh_directory_submit_review_dofollow = /** @type {(inputs: Directory_Submit_Review_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow（徽章已验证）`)
};

/**
* | output |
* | --- |
* | "Dofollow (badge verified)" |
*
* @param {Directory_Submit_Review_DofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_dofollow = /** @type {((inputs?: Directory_Submit_Review_DofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_DofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_dofollow(inputs)
	return zh_directory_submit_review_dofollow(inputs)
});
export { directory_submit_review_dofollow as "directory.submit.review.dofollow" }